module.exports = __webpack_public_path__ + "img/IMG_1699.09c7df95.webp";